<template>
  <div class="agreement">
    <div class="T_title" style="text-align: center">{{appName}} User Agreement</div>
    <div class="T_content">
      We hereby advise you to carefully read and understand this User Agreement (hereinafter referred to as “Agreement”)before registering.

      In order to clarify rights and obligations of all parties,and protect the legitimate rights and interests of all parties,this Agreement is specially formulated.the contents highlighted in bold underline in this Agreement are specially reminded of your attention.Please ensure that you fully understand this Agreement.You are not authorized to register ,log in or use our services or software(hereinafter referred to as services, software)unless you accept all the Agreement.Your registration,login,usage,etc.will bu deemed as acceptance of this Agreement and you agree to be bound by the Agreement.

      We reserve the right,at our discretion, to change,modify,add,or remove portions of the Agreement,sup;ementary Agreement,Privacy Policy,regulative provisions or feature terms at any time by posting the amended version on our software or within the services without prior noice.If you do not agree to these terms or any future amended version,then you must not access,use our services.Otherwise,your access,use of our services shall be deemed to agree any future updated version of them.

    </div>
    <div class="T_title">1.Account </div>
    <div class="T_content">
      1.1 In order to ues our services,We may ask you to create an Account or
      allocate an Account(hereinafter referred to as Account)to you.We can
      modify how your account is registered.
      <br /><br />
      1.2 You agree to simultaneously au theorize us to activate an account for
      other services of the company upon registration of this account.Specific
      products are subject to our actual operation.
      <br /><br />
      1.3 The ownership of the Account belongs to us and you only have the right
      to use the Account.You are forbidden to donate,borrow,rent,transfer or
      sell the Account.
      <br /><br />
      1.4 You are responsible for maintaining the security of your Account.If
      you Account encounter hacking or passwork theft due to your improper
      handling, you shall hold full responsibility for.We will treat all acts
      performed through your Account as being performed by you.You therefore
      accept responsibility for all acts done using your Account.If you become
      aware of any actual or suspected unauthorized use of your Account or
      Account passwork,please tellus immediately.You agree not to use other
      users’account or passwork under any circumstances.
      <br /><br />
      1.5 You shall abide by the terms of this Agreement and use the Software
      correctly and appropriately.If you violate any of the terms in this
      Agreement,we reserve the right to discontinus or terminate the Service to
      you.
      <br /><br />
      1.6 If no activity is conducted by you in relation to the Account for one
      year,we have the right to delete or take back the Account without prior
      notice to avoid wasting resources,and you shall take all the
      risks.Meanwhile,we reserve the right to delete or take back your Account
      and user name at any time at our sole discretion.
      <br /><br />
    </div>
    <div class="T_title">2.Service Scope</div>
    <div class="T_content">
      2.1 The specific Service of the Software is provided according to the
      actual situation,including but not limited to video chat,purchase or sent
      virtual gifts.We can modify the Service provided at any time without prior
      notice to you at our sole discretion.
      <br /><br />
      2.2 You understand and agree that we are entitled to send you promotional
      or other relewant business information,notices via email,client,push
      messages,SMS,webpage or other legal means for commercial purposes.Due to
      the unique nature of the mobile phone network,we have the right to access
      your mobile phone information.
      <br /><br />
    </div>
    <div class="T_title">3. User information protection</div>
    <div class="T_content">
      3.1 In the process of registering your Account or using the Service,you
      may be required to fill in or submit certain necessary informayion,such as
      the identity information required by laws,regulations,and regulatory
      documents(hereinafter referred to as “laws and regulations”).If the
      information you submit is incomplete,inaccurate or does not comply with
      the laws and regulations,you may bu unable,restricted to use our Service.
      <br /><br />
      3.2 In order to provide Service and improve quality of this Software ,our
      techniques,we may collect or use your information or disclose it to third
      parties.For more details,please read our “Privacy pOlicy”carefully.
    </div>

    <div class="T_title">4. Content Requirements and Usage Rules</div>
    <div class="T_content">
      4.1 The Content described in this Agreement refers to any content
      created,uploaded,copied,published and distributed by you,including but not
      limited to registration information and verification details such as
      account avatar,name,personal description,or text,
      audio,pictures,videos,graphics that are sent,replied or auto-reply
      messages and related link pages, and other content generated while using
      the software.
      <br /><br />
      4.2 You are not allowed to use this Softw are to produce, upload,copy and
      send the following Content or conduct the following behavior:
      <br /><br />
      1) That threatens national security,leaks state secrets, subverts state
      power, damages state unity;
      <br /><br />
      2) That damages national honor and profit;
      <br /><br />
      3) That incites national hatred, discrimination and damages national
      unity;
      <br /><br />
      4) That damages national religion policies,promotes cult and feudal
      superstition:
      <br /><br />
      5) That spreads rumors,disturbs public order and damages social stability;
      <br /><br />
      6) That spreads obscene,pornographic content containing sexual or sexually
      suggestive content;
      <br /><br />
      7) That spreads gambling,violence,murder,terror;
      <br /><br />
      8) That insults or defames others, violates others legal rights or
      fraudulent;
      <br /><br />
      9) That contains insulting, intimidating,or threatening content;
      <br /><br />
      10) That contains harassment,spam,malicious or phishing information;
      <br /><br />
      11) That disclosing or involving the privacy of others, personal
      information or details;
      <br /><br />
      12) That infringes on the legal rights of other people's
      reputation,portrait rights,intellectual property rights, trade
      secrets,etc.;
      <br /><br />
      13) That harms the interests of minors in any way;
      <br /><br />
      14) That stalks or otherwise harasses other users;
      <br /><br />
      15) That contains false information, or steals other people's avatars or
      details,posts or uses others' identity;
      <br /><br />
      16) That enforces, induces other users to follow,click on the link page or
      share information;
      <br /><br />
      17) That fabricates facts,conceals truths to mislead or deceive others;
      <br /><br />
      18) That contains advertising or sales-oriented information;
      <br /><br />
      19) That uses technical means to build multiple fake accounts;
      <br /><br />
      20) That deletes the copyright information on this software and its copy;
      <br /><br />
      21) That do reverse engineering,reverse compilation, de-compilation, or
      attempt to discover the source code of the software;
      <br /><br />
      22) That uses,rents, lends,copies modifies,links, reproduces,compiles,
      issues,publishes or creates mirror sites with contents that contains
      intellectual property rights of this company;
      <br /><br />
      23) That copies,modifies,adds, deletes,hooks,or creates any data released
      by us or necessary for the software,or derivatives;
      <br /><br />
      24) That adds, deletes, changes the function of the software,or operates
      or transmits the software to the public by modifying or falsifying the
      instructions and data in the software,whether or not for commercial
      purpose;
      <br /><br />
      25) That Loges in or uses the software through third- party
      software,hacking,plug-ins or systems that are not developed or authorized
      by us,or create,publish,or distribute third-party
      software,plug-ins,hackings, and systems that are not developed or
      authorized by the company;
      <br /><br />
      26) That is or could reasonably be viewed as offensive, indecent or
      objectionable;
      <br /><br />
      27) Other Contents or behaviors that in violation of laws and
      regulations,such as regulatory documents and policies(including
      jurisdiction where you reside, the Software operates, runs),or infringe
      lawful rights and interests of other third parties, interfere with the
      normal operation of the software. we will review your uploads and send the
      results within 24 hours of upload. If you use the app to make,upload,
      copy, publish and disseminate the above content, we have the right to
      delete the content you send,if there is any serious violation, we will
      block the account.
      <br /><br />
      4.3 Any Contents produced,uploaded,copied and sent by you has nothing to
      do with us and doesn't reflect or represent our
      opinion,standpoint,policy.We shall not be liable in any way for any
      Content uploaded, distributed,copied,published by you,or behavior
      conducted by you.
      <br /><br />
      4.4 You are solely responsible for the authenticity, legality,
      accuracy,validity of the information
      transmitted,produced,uploaded,copied,published, disseminated by you, and
      behaviors conducted, and performed by you. Any liability is at your own
      risk and has nothing to do with the software. If any damage is caused to
      us or third parties due to your behavior, you shall compensate losses of
      us or third parties, and we have the right to pursue your liability in
      accordance with this agreement.
      <br /><br />
    </div>
    <div class="T_title">5.Third Party Products and Services</div>
    <div class="T_content">
      5.1 The Service may contain advertisements and promotions offered by third
      parties and you agree to display those advertisements and promotions
      during the course of using the Service. Unless otherwise expressly
      regulated by laws and regulations,you should be responsible for
      transactions in accordance with the advertising information, and losses in
      relation to the transaction.We are not liable for any responsibility,
      losses arising from the aforesaid transactions.
      <br /><br />
      5.2 If you choose to use services,products provided by third party that
      displayed,linked on our Software, you shall comply with third party's
      agreement, policy in regard with you behavior. We cannot guarantee the
      security,accuracy, validity of third party's service and we are not
      responsible or liable for losses incurred by you arising from services,
      products, behavior of third party.
    </div>
    <div class="T_title">6.Membership</div>
    <div class="T_content">
      6.1 You can purchase membership service,and the included service content
      and price information is subject to the display on relevant service pages
      of this Service.
      <br /><br />
      6.2 We can adjust the membership service charge standard and content at
      any time by displaying the amended version on relative pages.
      <br /><br />
      6.3 You are forbidden to transfer or refund after successful payment under
      any circumstance unless clearly stated by Law and Regulation.The Service
      will terminate automatically after the end of subscription if you do not
      use our Service within the validity period specified in the payment
      service, which cannot be interrupted or postponed.
      <br /><br />
      6.4 The content and personal data you submitted when registering for
      membership must be valid and truthful. You must modify the registered
      personal data when necessary, otherwise you are liable for any
      consequences caused by your membership rights unable to fully and
      effectively exercised.
      <br /><br />
    </div>
    <div class="T_title">7. Subscriptions and Virtual Currency</div>
    <div class="T_content">
      7.1 Subscriptions
      You can buy different subscription packages according to one month, two months and three months.
      For all mobile subscriptions, the fee will be deducted from your iTunes or Google account when you confirm your purchase.
      Your subscription will be automatically renewed unless you turn off the automatic renewal feature at least 24 hours before
      the end of your current subscription. This is because your account may be charged for renewal within 24 hours before the
      end of the current subscription period. You can manage your subscriptions and turn off automatic renewal by accessing your
      iTunes or Google account settings. You cannot cancel the current subscription during the subscription period, but you can cancel automatic renewal at any time.
      <br /><br />
      Purchases of subscriptions are non refundable and non transferable, even if they expire or stop. We may change the
      purchase price of the subscription and the features included in the subscription at any time. We reserve the right
      to stop publishing and subscribing and set the subscription expiration date at any time. Subscriptions cannot be
      exchanged for any amount or currency value.
      <br /><br />
      7.2 Virtual Currency
      When you purchase or receive Virtual Currency products such as Diamonds you do not own them. Diamonds are used to upload stories, use
      filters and use video chat features, etc. You agree that we will have no liability to you based on the exercise of our rights with
      respect to coins and other Virtual Currencies. We reserve the right to verify your identity and eligibility to use your Virtual Currencies.
      <br /><br />
      We are not responsible for repairing or replacing Virtual Currencies, or providing you with any credit or refund in the event that we
      modify, suspend, or terminate the Virtual Currencies, or the Story, or for loss or damage due to any service error, or any other reason.
      Purchases of Virtual Currency may not be sub-licensed and are non-refundable and non-transferable, even if they expire or are revoked or
      discontinued. We may change the purchase price for Virtual Currency at any time, as well as the ways you can use Virtual Currency.
      We reserve the right to revoke or stop issuing Virtual Currency at any time without notice, refund, or compensation, and to set expiration
      dates for Virtual Currency. Virtual Currency may not be redeemed for any sum of money or monetary value. If you delete your account or your
      account is terminated for any reason, you will lose all accumulated and unused Virtual Currency without refund or other compensation.
      You agree that we will have no liability to you based on the exercise of our rights with respect to Virtual Currency.
      Virtual Currency purchased or received by any user does not constitute property and is not transferable.
      <br /><br />
      7.3 Payment Method
      Our paid services
      Our paid services can be purchased through your account with some third parties, such as your Apple iTunes account or your Google play
      account ("third party account"). If you purchase any paid services through a third-party account, the bill for these paid services will
      be displayed through your third-party account. You should review the terms of service for third-party accounts that we have no control over.
      <br /><br />
      7.4 Unsubscribe
      If you purchase a subscription through a third-party account, you will need to cancel your subscription through that third-party and in accordance
      with that third party’s terms of Service. If you cancel your subscription, your subscription benefits will continue until the end of your then-current
      subscription term, but your subscription will not be renewed after that term expires. You will not be entitled to a prorated refund of any portion of
      the subscription fees paid for the then-current subscription term.
      <br /><br />
      7.5 Term/Fees
      This Agreement shall remain in full force and effect while you use the mobile application and website and/or the Service. We may terminate your membership
      for any reason, at any time, without notice. If we terminate your Membership in the Service, you shall not be entitled to a refund of any unused portion of
      subscription fees, if any. Even after membership is terminated, this Agreement will remain in effect. Our Services' Terms of Service and/or subscription
      fees, if any, that were provided to you at registration is subject to change if needed. By using the Service and becoming a Member, you acknowledge that
      we reserve the right to charge for the Service and have the right to terminate a Member's Membership, should a Member breach this Agreement or fail to pay
      for the Service if necessary, as required by this Agreement. Standard usage charges for SMS, MMS, and other data charges may apply and may be billed on your
      wireless service bill or deducted from your prepaid balance.
      <br /><br />
    </div>
    <div class="T_title">8. Data Storage</div>
    <div class="T_content">
      8.1 We are not responsible for the deleting or storage failure of your
      data in this Service.
      <br /><br />
      8.2 We can determine the maximum storage time length and storage space of
      your data in the Service according to various factors.You can back up the
      relevant data of this Service according to your own needs.
      <br /><br />
      8.3 If you discontinue using the Service, or if the Service is terminated
      or ended,we can permanently delete your data from our server, and we are
      not obligated to return any data to you.
      <br /><br />
      8.4 You can modify or delete your personal data, registration information
      and Content uploaded, distributed by you.Please note that deleting
      relative information will lead to delete of Contents stored in the
      system.You are responsible for this risk.
      <br /><br />
    </div>
    <div class="T_title">9.Risk</div>
    <div class="T_content">
      9.1 You understand and agree that the Software only provides you with a
      platform for inform ation sharing, transmission.You are responsible for
      all actions under your Account,including any content you transmit and any
      consequences resulted.You should personally judge the content of the
      software and Service and bear all risks arising from the use of the
      Service,including risks arising from the reliance on the correctness,
      completeness or usefulness of the Content.We cannot and will not be liable
      for any losses caused by your behavior.
      <br /><br />
      9.2 If you find anyone who violates this agreement or uses the Service in
      other improper ways,please tell us immediately and we will deal with them
      according to this Agreement.
      <br /><br />
      9.3 You understand and agree that we reserve the right to
      change,suspend,terminate,update all or an feature of the Service in our
      sole discretion according to various factors without prior notice.
      <br /><br />
    </div>
    <div class="T_title">10. Intellectual Property</div>
    <div class="T_content">
      10.1 You acknowledge that intellectual property rights in and relating to
      our Services(other than Content which is contributed and owned by
      advertisers) is owned by us,unless you have legally acquired intellectual
      property rights in the Content posted by you on our Software before using
      our Services.
      <br /><br />
      10.2 Unless otherwise provided,the copyright,patent and other intellectual
      property rights of the Software are owned by us.
      <br /><br />
      10.3 the copyright or trademark rights of the graphics, text or its
      components involved in the Service,and other Software logos and product
      and Service names (hereinafter collectively referred to as the "Software
      Logo"),are owned by us.You are not allowed to display or use the Software
      logo in any way without our prior written consent,and you must not
      indicate to others that you have the right to display, use, or otherwise
      modify with the Software logo.
      <br /><br />
      10.4 The above and any other intellectual property rights owned by us or
      related advertisers are protected by law and you are not allowed to use or
      create derivative works in any form without the written permission of us
      or the relevant advertisers.
      <br /><br />
      10.5 Unless otherwise agreed in writing by the company and you/your
      agent,you own the intellectual property rights in connection with Content
      uploaded by you such as text,images,videos, audio,photograph,and you agree
      to authorize us and our affiliates a irrevocable, permanent
      exclusive,royalty-free,worldwide,sub- licensable right to use, display and
      reproduce the aforesaid Content for commercial or non-commercial purposes,
      including but not limited to adapt,display, broadcast,rent,copy,
      film,translate,or place such Content on Internet.We can choose whether to
      use and the usage method in our sole discretion,including but not limited
      to using and disseminating the above information on any platform operated
      by us, editing the above information, and authorize third party to use,
      edit,disseminate.
    </div>
    <div class="T_title">11. Liability</div>
    <div class="T_content">
      11.1 If you have illegal,wrongful,defaulting, tort act,we have the right
      in our sole discretion to take any or all of the following measures:to
      give a warning,to disable your ability to use some features,terminate your
      access to the Software,put you into blacklist,announce your default act,
      to deduct,withhold virtual items and virtual gains in part or in whole.If
      we adopt to terminate your Account,put you into blacklist,we have the
      right not to refund your virtual items, and gains. <br /><br />
      11.2 You understand and agree that we have right to take any remedy
      measures, appropriate legal action against your
      illegal,wrongful,defaulting,tort act, and disclose relevant information to
      authorities in accordance with laws and regulations and you shall bear all
      results.
      <br /><br />
      11.3 You understand and agree that any losses, damages, claims of third
      party arising out of your violation of this Agreement,shall be paid by
      you,including reasonable attorney's fees.
      <br /><br />
      11.4 You agree to indemnify,defend and hold harmless us,our affiliates
      from and against any and all
      comolaints.demands.claims.damages.losses.costs.liabilities and
      expenses,including but not limited to attorney's fees, arising out of your
      access to or use of the Service,your breach of this Agreement.
      <br /><br />
      11.5 We have the right to choose to apply the aforesaid rem edy measures
      separately or collectively.
      <br /><br />
    </div>
    <div class="T_title">12.Force Majeure And Other Disclaimers</div>
    <div class="T_content">
      12.1 You understand and acknowledge that in the course of using the
      Service, you may encounter problems out of our control, which m ay cause
      the Service to be interrupted.W e are not liable for any Service
      suspension,problems,losses out of our control and expectation,for example
      natural disasters such as floods,earthquakes,plague epidemics and
      storms,and social events such as war,turmoil,government actions, etc. In
      the event aforesaid,we will try our best to cooperate and to repair in
      time.
      <br /><br />
      12.2 We make no promises or guarantees that the Services will always
      safe,reliable,be available,uninterrupted,or error-free or not-delay.TO THE
      EXTENT PERMITTED BY APPLICABLE LAW,WE MAKE NO WARRANTIES,CONDITIONS,OR
      OTHER TERMS OF ANY KIND,EITHER EXPRESS OR IMPLIED,ABOUT THE SERVICES.WE
      DISCLAIM ANY WARRANTIES OF TITLE OR IMPLIED WARRANTIES,CONDITIONS,OR OTHER
      TERMS OF NON-INFRINGEMENT,MERCHANTABILITY, QUIET ENJOYMENT,OR FITNESS FOR
      A PARTICULAR PURPOSE.We do not control or manipulate actions of you and
      others,nor are we responsible for any of their content (whether online or
      offline) and any content they share (including
      offensive,indecent,obscene,illegal, and other contentious content).
      <br /><br />
      12.3 Like most Internet Services, our Service may be affected by various
      security issues, including but not limited to internet Service
      quality,social environment, other software,websites you
      download,install,visit may contain viruses such as "Trojan horses" that
      threaten the security of your computer information and data,which in turn
      affects the normal use of the Service.You should strengthen the protection
      of information security and user data, and pay attention to strengthen
      password protection to avoid loss and harassment.
      <br /><br />
      12.4 You understand and acknowledge that the Service has interruptions due
      to unavoidable issues,computer virus or hacking,system instability,your
      location,your shutdown,and any other technology problems,internet
      problems,telecom operate problems,etc.We shall not be liable for any
      losses caused due to the aforesaid interruptions.
      <br /><br />
      12.5 You understand and acknowledge that there may be some misleading,
      deceptive, threatening, defamatory, offensive or illegal information,or
      infringement information of the rights of others in the course of using
      the Service.We do not assume any responsibility for any losses of you or
      any third party resulting from aforesaid information or act.
      <br /><br />
      12.6 You understand and acknowledged that we may maintain,update,and
      repair features or this Software on a regular or irregular basis. If the
      service is interrupted within a reasonable period of time due to such
      circumstances with prior notice,we shall not be liable for this.
      <br /><br />
      12.7 Unless otherwise provided by law and regulation,we have rights but no
      obligation to handle any defaulting, tort, illegal act of third party and
      we cannot guarantee that the foresaid defaulting,tort,illegal act of third
      party shall be found,handled in times.
      <br /><br />
      12.8 You understand and acknowledge that we are not responsible for any
      defects in the quality of the products or Services offered to you and any
      damages caused by the free products or Services gifted to you.
      <br /><br />
      12.9 NOTWITHSTANDING OTHERWISE PROVIDED IN THIS AGREEMENT,YOU ACKNOWLEDGE
      THAT WE ARE NOT LIABLEFOR ANY INDIRECT,INCIDENTAL,SPECIAL, EXEMPLARY,OR
      CONSEQUENTIAL DAMAGES, INCLUDING FOR LOSS OF PROFITS,GOODWILL,OR DATA, IN
      ANY WAY WHATSOEVER ARISING OUT OF THE USE OF,OR INABILITY TO USE,THE
      SERVICES; ORFOR THE CONDUCT OF THIRD PARTIES, INCLUDING OTHER USERS OF THE
      SERVICES AND OPERATORS OF EXTERNAL SITES.IN ADDITION,ALL COMPENSATION,
      REMEDY,LIABILITIES,REGARDLESS OF ANY MANNER, REASON,SHALL NOT EXCEED ALL
      FEES PAID BY TO US (IF APPLICABLE)
      <br /><br />
      12.10 You acknowledge and understand that there may be personal and
      property security and transaction dispute risks if you meet,trade with
      other users offline, off the platform.We are not liable for the above
      risks or losses, and you must bear all responsibility.
      <br /><br />
    </div>
    <div class="T_title">13.Miscellaneous</div>
    <div class="T_content">
      13.1 We remind you to read this Agreement carefully, especially clauses in
      connection with disclaimer, risks, limitation of you rights and our
      liability. If you are a minor,pleases read with accompany of your
      guardian(s).
      <br /><br />
      13.2 You understand and agree that other statements, rules published by us
      in the software are deemed to be supplemental to these rules and are an
      integral part of these Rules and have the same legal effect as this
      Agreement.
      <br /><br />
      13.3 This Agreement shall be governed by, and construed in all respects in
      accordance with, the laws of the Hong Kong SAR. Any dispute arising out of
      or in connection with this Agreement, including any question regarding its
      existence,validity or termination,shall be referred to and finally
      resolved by arbitration administered by the Hong Kong International
      Arbitration Centre in accordance with the Arbitration Rules.
      <br /><br />
      13.4 The invalidity or unenforceability of any provision of this Agreement
      shall not in any way affect or impair the validity or enforceability of
      the remaining provisions.If any provision of this Agreement is declared
      invalid or unenforceable by competent authorities,the Parties shall use
      their best endeavors to agree upon a replacement provision so as to
      substantially effectuate the commercial purpose of the original provision.For more information, please send it via email【 anomi@anomi.site 】Contact us.
      <br /><br />
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {

      };
    },
    created() {
    }
  };
</script>

<style  scoped>
  .agreement {
    padding: 0px 25px;
  }
  .T_title {
    font-size: 1rem;
    font-weight: 600;
    margin: 1rem 0px;
    color: #666666;
  }
  .T_content {
    font-size: 1rem;
    margin-bottom: 1rem;
    color: #666;
  }
  .title_content {
    font-size: 0.2267rem;
    margin-bottom: 0.4667rem;
    color: #666;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
  }
</style>
